import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "lb-gallery" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "iconfont icon-upload"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1)
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload, {
      "list-type": "picture-card",
      "file-list": _ctx.fileList,
      "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
      name: _ctx.name,
      action: _ctx.action,
      headers: _ctx.headers,
      onPreview: _ctx.preview,
      onChange: _ctx.change
    }, {
      default: _withCtx(() => [
        (_ctx.fileList.length < _ctx.number)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "load"))
                : (_openBlock(), _createElementBlock("i", _hoisted_4)),
              _hoisted_5
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["file-list", "name", "action", "headers", "onPreview", "onChange"]),
    _createVNode(_component_a_modal, {
      centered: "",
      title: "预览",
      visible: _ctx.visible,
      footer: null,
      onCancel: _ctx.cancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          style: {"width":"100%"},
          src: _ctx.src
        }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ]))
}